import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrl, IrisBaseCRUDService } from '@iris/api-query';
import { IrisBuildingI } from '@iris/common/models/IrisBuilding';

/**
 * @deprecated don't use this service anymore
 * use instead {@link IrisBuildingsV2Service}
 */
@Injectable({
  providedIn: 'root',
})
@ApiUrl('/construction/buildings')
export class IrisBuildingsService extends IrisBaseCRUDService<IrisBuildingI> {
  constructor() {
    const httpClient = inject(HttpClient);

    super(httpClient);
  }

}
